export default "__VITE_ASSET__BjryyJzH__"